// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-86628370] .expand-item .el-form-item__content{line-height:1;margin-top:4px}.invoice-person[data-v-86628370]{font-size:14px;color:#333;margin-top:20px}.check-notice[data-v-86628370]{text-align:center;margin-bottom:22px}.img-item.el-form-item.is-error[data-v-86628370]{margin-bottom:40px}", ""]);
// Exports
module.exports = exports;
